import UltMeta, { Meta } from "./UltMeta/index";

class TrajectoryType extends UltMeta {
    SHIP = new Meta(1, "船运");
    VEHICLE = new Meta(2, "汽运");
}
export const TRAJECTORY_TYPE = new TrajectoryType();
